import * as z from 'zod';

import { paymentMethodQueryLinkerSchema } from '@/_pages/settings/payment-methods/shared';
import { fileQuerySchema } from '@/_schemas/file';
import { booleanQuerySchema, paginatedResponseSchema } from '@/_schemas/generic';

import { invoiceQuerySchema } from '../invoices/invoice-query-schema';

export const invoiceBatchQuerySchema = z.object({
  id: z.number(),
  name: z.string(),
  invoices: z.array(invoiceQuerySchema).optional(),
  created_at: z.string(),
  is_paid: booleanQuerySchema(),
  inherit_agreement_creation_date: booleanQuerySchema(),
  inherit_invoice_date_for_payment_date: booleanQuerySchema(),
  invoices_creation_date: z.string().nullable(),
  payment_date: z.string().nullable(),
  payment_method: paymentMethodQueryLinkerSchema.nullable(),
  payment_method_id: z.number().nullable(),

  printable_invoices_pdf: z.array(fileQuerySchema).nullish(),
  digital_invoices_pdf: z.array(fileQuerySchema).nullish(),

  is_generating_pdfs: z.boolean().nullish(),
  invoice_batch_started: z.boolean().nullish(),
});

export type InvoiceBatchQuerySchema = z.infer<typeof invoiceBatchQuerySchema>;

export const invoiceBatchQueryAllSchema = paginatedResponseSchema(invoiceBatchQuerySchema);

export type InvoiceBatchQueryAllSchema = z.infer<typeof invoiceBatchQueryAllSchema>;
